import { RequestCards } from "@src/features/creatingRequest/ui/RequestCards";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import { getAttemptsWord } from "@src/features/tariff-selection/ui/utils";
import { LastRequests } from "@src/features/lastRequests";
import { WrapperLoading } from "@src/shared/components";
import { useSearchResult } from "@src/widgets/SearchResult/api/useSearchResult";
import { useEffect, useRef } from "react";
import { useNotificationsStore } from "@src/entities/notifications/model/store/notificationsStore";

import styles from "./MainPage.module.scss";

export function MainPage() {
  const userMe = useUserInfoMeStore((state) => state.user);
  const lastLiveEvent = useNotificationsStore((s) => s.lastLiveEvent);
  const handledLiveEventIdRef = useRef<string | null>(null);
  const { items, isLoading, getSearchResult } = useSearchResult();
  const { availableAttempts } = (userMe?.owned_licenses || []).reduce(
    (acc, license) => {
      const { available_attempts, used_request } = license;

      if (license.is_active) {
        const remainingAttempts = available_attempts - used_request;
        acc.availableAttempts += remainingAttempts;
      }

      return acc;
    },
    { availableAttempts: 0 },
  );

  useEffect(() => {
    getSearchResult(1);
  }, []);

  useEffect(() => {
    if (!lastLiveEvent) return;

    if (handledLiveEventIdRef.current === lastLiveEvent.id) return;

    if (lastLiveEvent.type === "MATCHING_REQUEST_DONE") {
      handledLiveEventIdRef.current = lastLiveEvent.id;
      getSearchResult(1, false);
    }
  }, [lastLiveEvent, getSearchResult]);

  const lastRequests = items?.slice(0, 5) || [];

  return (
    <WrapperLoading isLoading={isLoading}>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <h1 className={styles.title}>Создать запрос</h1>
          <div className={styles.attemptsAvailable}>
            <span className={styles.text}>Доступно:</span>
            <span className={styles.attempts}>
              {getAttemptsWord(availableAttempts)}
            </span>
          </div>
        </div>
        <div className={styles.content}>
          <RequestCards />
        </div>
        <LastRequests items={lastRequests} />
      </div>
    </WrapperLoading>
  );
}
